import script from "./ChatDetailMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailMessage.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailMessage.vue?vue&type=style&index=0&id=752f3570&lang=scss"

const __exports__ = script;

export default __exports__